import DotsNavigation from "./multi-indicator/DotsNavigation";
import NumberNavigation from "./single-indicator/NumberNavigation";
import ImageNavigation from "./multi-indicator/ImageNavigation";

export { DotsNavigation, NumberNavigation, ImageNavigation };

export const category = (navigationType: string) => {
  if (navigationType === "image" || navigationType === "dots") {
    return "multi-indicator";
  }
  if (navigationType === "number") {
    return "single-indicator";
  }
  return "none";
};
